import { useLoanCardHistory } from '../data/hooks';
import { errorText } from '../lib/errors';
import { fmtWeekdayDateTime } from '../lib/format';
import { Badge, Panel } from './ui';

/** Persoonspagina van een uitleenpas: wie had de pas wanneer (om het logboek te duiden). */
export function LoanHistoryPanel({ orgId, personId }: { orgId: string; personId: string }) {
  const hist = useLoanCardHistory(orgId, personId);
  const rows = hist.data ?? [];
  return (
    <Panel
      title="Uitleenpas"
      description="Dit is een uitleenpas voor gasten. Uitlenen en innemen gaat op de pagina Uitleenpassen. Hieronder zie je wie de pas wanneer had."
    >
      {hist.isLoading ? (
        <p className="tile-empty">Laden…</p>
      ) : hist.error ? (
        <p className="tile-empty">{errorText(hist.error, 'Kon de geschiedenis niet laden.')}</p>
      ) : rows.length === 0 ? (
        <p className="tile-empty">Nog nooit uitgeleend.</p>
      ) : (
        <ul className="tile-list">
          {rows.map((l) => (
            <li key={l.id}>
              <span>
                <span className="primary">
                  {l.guest_name}
                  {l.guest_club ? `, ${l.guest_club}` : ''}
                </span>
                <span className="cell-sub">
                  {fmtWeekdayDateTime(l.loaned_at)} tot{' '}
                  {l.returned_at ? fmtWeekdayDateTime(l.returned_at) : `nu (terug ${fmtWeekdayDateTime(l.due_at)})`}
                </span>
              </span>
              {!l.returned_at && (
                <Badge tone={new Date(l.due_at) < new Date() ? 'red' : 'ink'}>
                  {new Date(l.due_at) < new Date() ? 'Te laat' : 'Uitgeleend'}
                </Badge>
              )}
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
}
